import { createFragmentRegistry } from '@apollo/client/cache';

import { TrelloCardActionsFieldsFragmentDoc } from './actions/TrelloCardActionsFragment.generated';
import { TrelloCommentCardActionFieldsFragmentDoc } from './actions/TrelloCommentCardActionFragment.generated';
import { TrelloCopyCardActionFieldsFragmentDoc } from './actions/TrelloCopyCardActionFragment.generated';
import { TrelloCopyCommentCardActionFieldsFragmentDoc } from './actions/TrelloCopyCommentCardActionFragment.generated';
import { TrelloCopyInboxCardActionFieldsFragmentDoc } from './actions/TrelloCopyInboxCardActionFragment.generated';
import { TrelloCoreActionFieldsFragmentDoc } from './actions/TrelloCoreActionFieldsFragment.generated';
import { TrelloCreateCardActionFieldsFragmentDoc } from './actions/TrelloCreateCardActionFragment.generated';
import { TrelloCreateInboxCardActionFieldsFragmentDoc } from './actions/TrelloCreateInboxCardActionFragment.generated';
import { BoardListsContextCardFragmentDoc } from './BoardListsContextCardFragment.generated';
import { BoardListsContextListFragmentDoc } from './BoardListsContextListFragment.generated';
import { CheckItemFullFragmentDoc } from './CheckItemFullFragment.generated';
import { CurrentBoardFullCardFragmentDoc } from './CurrentBoardFullCardFragment.generated';
import { CurrentBoardFullListFragmentDoc } from './CurrentBoardFullListFragment.generated';
import { EnabledCalendarsFieldsFragmentDoc } from './EnabledCalendarsFieldsFragment.generated';
import { EventsFieldsFragmentDoc } from './EventsFieldsFragment.generated';
import { PlannerCardFrontFieldsFragmentDoc } from './PlannerCardFrontFieldsFragment.generated';
import { ProviderCalendarFieldsFragmentDoc } from './ProviderCalendarFieldsFragment.generated';
import { TrelloAllCardBadgesFragmentDoc } from './TrelloAllCardBadgesFragment.generated';
import { TrelloMirrorCardSubscriptionCardFragmentDoc } from './TrelloMirrorCardSubscriptionCardFragment.generated';

// eslint-disable-next-line @trello/no-module-logic
export const fragmentRegistry = createFragmentRegistry(
  BoardListsContextCardFragmentDoc,
  BoardListsContextListFragmentDoc,
  CheckItemFullFragmentDoc,
  CurrentBoardFullCardFragmentDoc,
  CurrentBoardFullListFragmentDoc,
  EnabledCalendarsFieldsFragmentDoc,
  EventsFieldsFragmentDoc,
  PlannerCardFrontFieldsFragmentDoc,
  ProviderCalendarFieldsFragmentDoc,
  TrelloMirrorCardSubscriptionCardFragmentDoc,
  TrelloAllCardBadgesFragmentDoc,
  // Action fragments
  TrelloCardActionsFieldsFragmentDoc,
  TrelloCoreActionFieldsFragmentDoc,
  TrelloCommentCardActionFieldsFragmentDoc,
  TrelloCopyCardActionFieldsFragmentDoc,
  TrelloCopyCommentCardActionFieldsFragmentDoc,
  TrelloCopyInboxCardActionFieldsFragmentDoc,
  TrelloCreateCardActionFieldsFragmentDoc,
  TrelloCreateInboxCardActionFieldsFragmentDoc,
);
